var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlur08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 521,
    height: 336,
    viewBox: "0 0 521 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22,
    filter: "url(#filter0_f_52_11236)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 335.5,
    r: 186.5,
    fill: "#5B21B6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_52_11236",
    x: -400,
    y: -125,
    width: 921,
    height: 921,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 137,
    result: "effect1_foregroundBlur_52_11236"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlur08);
export default __webpack_public_path__ + "static/media/blur-08.e76fa4c91ce228934220c4a95892ce25.svg";
export { ForwardRef as ReactComponent };